import React from "react"
import Button from "../../../components/button"

const ExternalLogin = ({ info }) => {  
  const handleRedirect = () => {
    window.location = info.redirect_url
  }

  return (
    <div className="flex flex-column items-center">
      {info.logo_url && <div className="flex">
        <img src={info.logo_url} style={{ maxWidth: '100%', padding: '32px' }} alt={`Logo for ${info.organization_name}`}/>
      </div>}
      <p>{info?.header_text}</p>
      <Button className="cs-button" onClick={handleRedirect}>
        {info?.button_text}
      </Button>
    </div>
  )
}

export default ExternalLogin
